import createReactComponent from '../createReactComponent';
var Edit3 = createReactComponent('Edit3', [['path', {
  d: 'M12 20h9',
  key: 't2du7b'
}], ['path', {
  d: 'M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z',
  key: '128b8n'
}]]);
export default Edit3;